import actions from './bug.actions'

export default {
  namespaced: true,
  state: {},
  actions
}
